/**
 * Insurance Requests Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncIncomingMoneyReportComponent,
  AsyncInsuranceCompaniesReportComponent,
  AsyncAgencyRatiosReportComponent,
  AsyncAgencyActivityReportComponent,
  AsyncAgencyActivity2ReportComponent,
  AsyncAgencyAdvancedReportsComponent,
  AsyncInsurancesComparisonReportComponent,
  AsyncAgenciesHasDebtReportComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/incoming-money`}
        component={AsyncIncomingMoneyReportComponent}
      />
      <Route
        path={`${match.url}/insurance-companies`}
        component={AsyncInsuranceCompaniesReportComponent}
      />
      <Route
        path={`${match.url}/agency-ratios`}
        component={AsyncAgencyRatiosReportComponent}
      />
      <Route
        path={`${match.url}/agency-activity`}
        component={AsyncAgencyActivityReportComponent}
      />
      <Route
        path={`${match.url}/agency-activity2`}
        component={AsyncAgencyActivity2ReportComponent}
      />
      <Route
        path={`${match.url}/advanced-reports`}
        component={AsyncAgencyAdvancedReportsComponent}
      />
      <Route
        path={`${match.url}/insurances-comparison`}
        component={AsyncInsurancesComparisonReportComponent}
      />
      <Route
        path={`${match.url}/agencies-who-has-debt`}
        component={AsyncAgenciesHasDebtReportComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
